import React from 'react'

const DrugDetails = () => {
  return (
    <div>DrugDetails</div>
  )
}

export default DrugDetails